import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import {
  ArrayInput,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
} from "react-admin";
import { formatStudentOption } from "../../utils";
import { StudentStateExamStatus } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import { useFormContext } from "react-hook-form";

import { useInput } from "react-admin";

const GradeInput = ({ scopedFormData }) => {
  const { field } = useInput({ source: "grade" });
  const { setValue } = useFormContext();

  const status = Number(scopedFormData?.status);

  useEffect(() => {
    if (status === StudentStateExamStatus.Attended) {
      setValue(field.name, undefined);
    }

    if (status === StudentStateExamStatus.NotAttended) {
      setValue(field.name, undefined);
    }

    if (status === StudentStateExamStatus.Disqualified) {
      setValue(field.name, 2);
    }
  }, [status, field.name, setValue]);

  const isAttended = status === StudentStateExamStatus.Attended;

  return (
    <NumberInput
      source="grade"
      label="Оценка"
      min={2}
      max={6}
      validate={isAttended ? required() : undefined}
      readOnly={!isAttended}
    />
  );
};

const CreateForm = ({ students }) => {
  const defaultValue = students?.map(s => ({
    studentEducationId: s.studentEducationId,
    grade: undefined,
    points: undefined,
    status: StudentStateExamStatus.Attended,
  }));

  return (
    <ArrayInput
      source="results"
      label="Резултати"
      defaultValue={defaultValue}
    >
      <SimpleFormIterator
        disableAdd
        disableRemove
        disableReordering
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <ReferenceInput
              source="studentEducationId"
              reference={graduationRequests.getInternshipStudentsSelect()}
            >
              <SelectInput
                source="studentEducationId"
                optionValue="studentEducationId"
                optionText={formatStudentOption()}
                emptyText={false}
                label="Студент"
                readOnly
              />
            </ReferenceInput>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <ReferenceInput
              source="status"
              reference={graduationRequests.getStateExamsStatusesSelect()}
            >
              <SelectInput
                optionText="nameBg"
                label="Статус"
                emptyText={false}
                validate={required()}
              />
            </ReferenceInput>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
          >
            <FormDataConsumer>
              {({ scopedFormData }) => <GradeInput scopedFormData={scopedFormData} />}
            </FormDataConsumer>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
          >
            <NumberInput
              source="points"
              label="Точки"
            />
          </Grid>
        </Grid>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default CreateForm;
